<template>
  <div class="layout__container">
    <div class="layout__margin-25-0">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>Sales Insight</el-breadcrumb-item>
        <el-breadcrumb-item><span class="text__colour-teal">Bespoke Reports</span></el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="layout__position-center">
      <div class="layout__position-left layout__width-100">
        <div class="layout__search-field__insights-250px">
          <p class="layout__margin__bottom-10 text__align-left">Select Report</p>
          <el-select
            v-model="dropdownValue"
            placeholder="Select Report"
            clearable
            @change="swapComponent"
          >
            <el-option
              v-for="component in componentsArray"
              :key="component.value"
              :label="component.label"
              :value="component.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="layout__position-left layout__width-100">
        <div id="toReplace">
          <div :is="currentComponent"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomerHeatmap from '@/views/insights/reports/CustomerHeatmap';
import DirectMailSpend from '@/views/insights/reports/DirectMailSpend';
import DirectMailrRevenue from '@/views/insights/reports/DirectMailrRevenue';
import LapsedBranchesReport from '@/views/insights/reports/LapsedBranchesReport';
import ClientsListSalesTerritoryReport from '@/views/insights/reports/ClientsListSalesTerritoryReport';
import ActiveCustomersReport from '@/views/insights/reports/ActiveCustomersReport';
import NoSpendReport from '@/views/insights/reports/NoSpendReport';
import NewBranchesReport from '@/views/insights/reports/NewBranchesReport';
import AbandonedOrdersReport from '@/views/insights/reports/AbandonedOrdersReport';
import { axios } from '@/mixins/Axios.js';

export default {
  name: 'sales',

  mixins: [axios],

  components: {
    CustomerHeatmap,
    DirectMailSpend,
    DirectMailrRevenue,
    LapsedBranchesReport,
    ClientsListSalesTerritoryReport,
    ActiveCustomersReport,
    NoSpendReport,
    NewBranchesReport,
    AbandonedOrdersReport,
  },

  props: {
    view: '',
  },

  created() {
    this.isUserAuthorised();
  },

  data() {
    return {
      dropdownValue: '',
      currentComponent: null,
      componentsArray: [
        {
          value: 'CustomerHeatmap',
          label: 'Customer Heatmap',
        },
        {
          value: 'DirectMailSpend',
          label: 'Direct Mail Spend',
        },
        {
          value: 'DirectMailrRevenue',
          label: 'Directmailr Spend',
        },
        {
          value: 'LapsedBranchesReport',
          label: 'Lapsed Branches',
        },
        {
          value: 'ClientsListSalesTerritoryReport',
          label: 'Client List for sales territory',
        },
        {
          value: 'NewBranchesReport',
          label: 'New users from last month',
        },
        {
          value: 'NoSpendReport',
          label: 'Lapsed for last 6-12 months excluding corporates',
        },
        {
          value: 'ActiveCustomersReport',
          label: 'All active customers',
        },
        {
          value: 'AbandonedOrdersReport',
          label: 'Abandoned Orders Report',
        },
      ],
    };
  },

  methods: {
    swapComponent: function (component) {
      console.log('dropdownValue=' + this.dropdownValue);
      this.currentComponent = component;
    },
  },
};
</script>